import { AxiosError } from "axios";

export const getErrorMessage = (error: unknown, fallback?: string) => {
  if (error instanceof AxiosError) {
    if (error.response?.data?.error?.message)
      return error.response.data?.error?.message;
    if (error.response?.data?.error?.errors)
      return error.response.data?.error?.errors.reduce(
        (acc: any, error: any, idx: number) =>
          acc + `${idx !== 0 ? ", " : ""}${error}`,
        ""
      );
  }

  if (error instanceof Error) return error.message;

  return fallback || "Something went wrong, please try again later";
};
